import "../style.css";
import {
  Stack,
  Divider,
  Typography,
  TextField,
  CardHeader,
  CardActions,
  Button,
  CircularProgress,
  Box,
  Avatar,
  Card,
  Skeleton,
  Tooltip,
} from "@mui/material";
import StepItem from "./StepItem";
import SequenceStepEmailContent from "./SequenceStepEmailContent";
import { convertSecondsToUnitTime } from "src/utils/time";
import SequenceStepLinkedinContent from "./SequenceStepLinkedinContent";
import { useEffect, useState } from "react";
import { API_SERVICE_BACKEND } from "src/config";
import { getBlobUrl } from "src/utils/getBlobUrl";
import axios from "axios";
import { TaskAlt } from "@mui/icons-material";
import PhoneCallSequenceStep from "./PhoneCallSequenceStep";

export const LinkedInConnectionRequest = ({
  providers,
  linkedinURL,
  template,
  withMessage,
  content,
}) => {
  const linkedin = providers?.linkedin;
  const [linkedinProfile, setLinkedinProfile] = useState({});
  const [linkedinData, setLinkedinData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const accountId = linkedin?.accountId;
  const getLinkedinProfile = async () => {
    try {
      const publicIdentifier = linkedinURL.split("/").filter(Boolean).pop();
      const res = await axios.get(
        `${API_SERVICE_BACKEND}/unipile/linkedin/getUserProfile?accountId=${accountId}&identifier=${publicIdentifier}`
      );
      if (!res.data) return;
      setLinkedinProfile(res.data);
      setIsFetching(false);
    } catch (err) {
      setIsFetching(false);
      //console.log(err);
    }
  };
  const handleConnect = () => {
    setIsLoading(true);
    setTimeout(() => {
      setLinkedinProfile({
        ...linkedinProfile,
        invitation: { status: "PENDING" },
      });
      setIsLoading(false);
    }, 2000);
  };
  const handleCancelInvitation = async (invitationId) => {
    setIsLoading(true);
    const res = await axios.post(
      `${API_SERVICE_BACKEND}/unipile/linkedin/cancelInvitation`,
      {
        accountId: accountId,
        providerId: linkedinProfile.provider_id,
      }
    );

    if (!res.data) return;
    setLinkedinProfile({
      ...linkedinProfile,
      invitation: { status: "WITHDRAW" },
    });
    setIsLoading(false);
  };
  const fetchEmailContent = async () => {
    const res = await axios.get(
      `${API_SERVICE_BACKEND}/getEmailSentInfo?id=${content}`
    );
    if (!res.data) return;
    setLinkedinData({
      clicked: res.data.clicked,
      opened: res.data.opened,
      email: res.data.email,
      from: res.data.from,
      to: res.data.to,
      sentAt: res.data.createdAt,
    });
    // sortedClicks = res?.data?.clicked?.reverse();
    // sortedOpens = res?.data?.opened?.reverse();
  };
  useEffect(() => {
    if (linkedinURL && accountId) {
      if (content && typeof content === "string") {
        fetchEmailContent();
      }
      setIsFetching(true);
      getLinkedinProfile();
    }
  }, [linkedinURL]);

  return linkedinProfile.first_name || isFetching ? (
    <Box
      sx={{
        width: "auto",
        margin: "auto",
        marginTop: "20px",
        padding: "20px",
        borderRadius: "10px",
        //boxShadow: 3,
        //bgolor: "#f3f2ef",
      }}
    >
      <Card
        key={linkedinProfile?.id}
        sx={{
          display: "flex",
          alignItems: "center",
          marginBottom: "10px",
          boxShadow: 1,
          p: 1,
        }}
        className="glass-wrapper-25"
      >
        {isFetching && !linkedinProfile?.profile_picture_url ? (
          <Skeleton
            variant="circular"
            width={40}
            height={40}
            sx={{ margin: "10px" }}
          />
        ) : !isFetching && !linkedinProfile?.profile_picture_url ? (
          <Avatar sx={{ bgcolor: "#0a66c2", margin: "10px" }}>
            {linkedinProfile?.name?.charAt(0)}
          </Avatar>
        ) : (
          <Avatar
            alt="User"
            src={
              linkedinProfile?.profile_picture_url
                ? (getBlobUrl(linkedinProfile?.profile_picture_url) || linkedinProfile?.profile_picture_url)
                : "https://www.w3schools.com/howto/img_avatar.png"
            }
            sx={{ width: 32, height: 32, margin: "10px" }}
          />
        )}

        <Box sx={{ flex: 1 }}>
          {isFetching ? (
            <Skeleton variant="text" width="80%" height={20} />
          ) : (
            <CardHeader
              title={
                linkedinProfile.first_name + " " + linkedinProfile.last_name
              }
              subheader={linkedinProfile.headline}
              sx={{ padding: "0" }}
            />
          )}
        </Box>

        <CardActions>
          {linkedinProfile?.invitation?.status == "WITHDRAWN" ? (
            <Button variant="text" disabled>
              Cancelled
            </Button>
          ) : linkedinProfile?.invitation?.status == "IGNORED" ? (
            <Tooltip
              title={`Invitation Ignored by ${linkedinProfile.first_name} ${linkedinProfile.last_name}`}
              arrow
            >
              <Typography variant="text" color={"error"} fontWeight={700}>
                Rejected
              </Typography>
            </Tooltip>
          ) : (
            linkedinProfile?.invitation?.status == "PENDING" && (
              <Button
                variant="outlined"
                size="small"
                onClick={() => handleCancelInvitation()}
                disabled={isLoading}
                className="glass-button-secondary-50"
                startIcon={
                  isLoading && <CircularProgress size={16} color="inherit" />
                }
              >
                Withdraw
              </Button>
            )
          )}

          {linkedinProfile.is_relationship && (
            <Tooltip title="Invitation Accepted" arrow>
              <Typography variant="text" disabled>
                <TaskAlt sx={{ color: "success" }} />
              </Typography>
            </Tooltip>
          )}
          {!isFetching && !linkedinProfile?.invitation?.status &&
            !linkedinProfile.is_relationship && (
              <Typography>Declined</Typography>
            )}
        </CardActions>
      </Card>
      {withMessage && (
        <Box
          sx={{
            fontSize: "16px",
            color: "text.secondary",
            marginBottom: "10px",
            '& img': {
              maxWidth: '100%',
              height: 'auto',
              display: 'block',
            },
          }}
          dangerouslySetInnerHTML={{
            __html: linkedinData?.email?.html,
          }}
        />
      )}
    </Box>
  ) : (
    <Box
      sx={{
        width: "400px",
        margin: "auto",
        marginTop: "20px",
        padding: "20px",
        borderRadius: "10px",
        boxShadow: 3,
        bgolor: "#f3f2ef",
      }}
      className="glass-wrapper-25"
    >
      <Typography
        sx={{
          fontSize: "16px",
          color: "text.primary",
          marginBottom: "10px",
          textAlign: "center",
        }}
        disabled
      >
        Invitation Not Sent Yet
      </Typography>
    </Box>
  );
};

export const SequenceStepTimeline = (props) => {
  const { emailSeqStatus, steps, lead } = props;
  const getStepContent = (step, emailSeqStatus, index) => {
    switch (step?.type) {
      case "email.scratch":
        return (
          <SequenceStepEmailContent
            template={step?.variants?.value[0]?.template}
            content={emailSeqStatus?.initial?.prospect[`${index + 1}`]}
          />
        );
      case "in.message":
        return (
          <SequenceStepLinkedinContent
            template={step?.variants?.value[0]?.template}
            providers={lead?.multiChannel}
            linkedinURL={lead?.linkedin_url}
            content={
              emailSeqStatus?.in_message?.prospect?.[`${index + 1}`] ??
              emailSeqStatus?.in_message?.[`${index + 1}`]?.error
            }
          />
        );
      case "in.connect":
        return (
          <LinkedInConnectionRequest
            providers={lead?.multiChannel}
            linkedinURL={lead?.linkedin_url}
            template={step?.variants?.value[0]?.template}
            withMessage={step?.withMessage}
            content={
              emailSeqStatus?.in_connect?.prospect?.[`${index + 1}`] ??
              emailSeqStatus?.in_connect?.[`${index + 1}`]?.error
            }
          />
        );
      case "outbound_call": {
        return (
          <PhoneCallSequenceStep
            template={step?.variants?.value[0]?.data}
            providers={lead?.multiChannel}
            content={
              emailSeqStatus?.outbound_call?.prospect?.[`${index + 1}`] ??
              emailSeqStatus?.outbound_call?.[`${index + 1}`]?.error
            }
          />
        )
      }
      default:
        return null;
    }
  };

  const isStepCompleted = (step, emailSeqStatus, index) => {
    switch (step.type) {
      case "email.scratch":
        return emailSeqStatus?.initial?.prospect?.[`${index + 1}`];
      case "in.message":
        return emailSeqStatus?.in_message?.prospect?.[`${index + 1}`];
      case "in.connect":
        return emailSeqStatus?.in_connect?.prospect?.[`${index + 1}`];
      case "outbound_call":
        return emailSeqStatus?.outbound_call?.prospect?.[`${index + 1}`];
      default:
        return false;
    }
  };
  const isStepFail = (step, emailSeqStatus, index) => {
    switch (step.type) {
      case "email.scratch":
        return emailSeqStatus?.initial?.[`${index + 1}`]?.error;
      case "in.message":
        return emailSeqStatus?.in_message?.[`${index + 1}`]?.error;
      case "in.connect":
        return emailSeqStatus?.in_connect?.[`${index + 1}`]?.error;
      case "outbound_call":
        return emailSeqStatus?.outbound_call?.[`${index + 1}`]?.error;
      default:
        return false;
    }
  };
  // filter out deleted steps before rendering but keep original index
  const visibleStepsWithIndices = Array.isArray(steps)
    ? steps
        .map((step, index) => ({ step, index }))
        .filter(({ step }) => !step?.isDeleted && !step?.deleted)
    : [];

  return (
    <Stack
      spacing={3}
      // gap={3}
      direction="column"
      className="contentBorder glass-wrapper-50"
    >
      {visibleStepsWithIndices.map(({ step, index }, visibleIndex) => {
        return (
          <Box key={index}>
            <StepItem
              stepNum={visibleIndex + 1}
              stepTitle={step?.label ?? `Step ${visibleIndex + 1}`}
              stepText={`${convertSecondsToUnitTime(
                step.nextStep.delay.seconds,
                step.nextStep.delay.unit
              ) || ""} ${step.nextStep.delay.unit.toUpperCase()} AFTER PREVIOUS STEP`}
              stepDelayUnit={step.nextStep.delay.unit ?? "days"}
              stepContent={getStepContent(step, emailSeqStatus, index)}
              completed={isStepCompleted(step, emailSeqStatus, index)}
              deleted={step?.isDeleted}
              error={isStepFail(step, emailSeqStatus, index)}
            />
            {visibleIndex < visibleStepsWithIndices.length - 1 && (
              <Divider sx={{ "&.MuiDivider-root": { my: 0 } }} />
            )}
          </Box>
        );
      })}
      {lead?.multiChannel?.linkedin?.chatId && (
        <Box sx={{ mt: 0, px: 2, pb: 2 }}>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 700 }}>
            Full LinkedIn Conversation
          </Typography>
          <SequenceStepLinkedinContent
            providers={lead?.multiChannel}
            linkedinURL={lead?.linkedin_url}
            content={null}
          />
        </Box>
      )}
    </Stack>
  );
};
